import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {UserPermissions} from '../../../../shared/interface/user-permissions';
import {AuthService} from '../../../../shared/services/auth.service';
import {CommissionAnnex} from '../../../../shared/interface/commission-annex';

@Component({
  selector: 'app-annex-group-view',
  templateUrl: './annex-group-view.component.html',
  styleUrls: ['./annex-group-view.component.scss']
})
export class AnnexGroupViewComponent implements OnInit {
  @Input() annex: CommissionAnnex;
  @Output() modifyClicked = new EventEmitter<any>();

  userPermissions: ReplaySubject<UserPermissions>;

  constructor(
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
  }

  modify(): void {
    this.modifyClicked.emit();
  }

}
